import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalController, App } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { ToolsProvider } from '../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../environments/environment';
import { ConfigProvider } from '../../providers/config/config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'drawer',
  templateUrl: 'drawer.html',
})
export class DrawerComponent {
  log = debug('app:DrawerComponent');

  @Output()
  close = new EventEmitter();
  authenticated = false;
  isVip = false;
  versionNumber = null;
  buildNumber = null;
  devMode = false;
  branchKey = '';
  userNavBlocked = false;
  karmaMile;
  karmaMileInvites;
  selectedNav: number | null = null;

  constructor(
    public modalCtrl: ModalController,
    public user: UserProvider,
    public appCtrl: App,
    public tools: ToolsProvider,
    public appVersion: AppVersion,
    private env: EnvVariables,
    public configs: ConfigProvider
  ) {
    this.log('DrawerComponent Component');
    if (localStorage.getItem('ENV_DEV_OVERRIDE')) {
      this.devMode = true;
    }

    this.branchKey = this.env.branchKey;

    this.appVersion
      .getVersionNumber()
      .then(
        versionNumber => {
          this.versionNumber = versionNumber;
        },
        error => {}
      )
      .then(() => {
        if (localStorage.getItem('FAKED_VERSION')) {
          this.versionNumber = localStorage.getItem('FAKED_VERSION');
        }
      });

    this.appVersion.getVersionCode().then(
      versionCode => {
        this.buildNumber = versionCode;
      },
      error => {}
    );
  }

  ngOnInit(): void {
    this.isVip = _.get(this.user.info, 'states.isVIP') ? true : false;

    this.configs.on('loaded', d => {
      this.karmaMileInvites =
        _.get(this.configs.get('karmaMiles'), 'inviteUser', 10) *
        _.get(this.configs.get('karmaMiles'), 'inviteMaxSends', 1);
    });

    this.setUserKarmaMiles();
    this.user.on('updated', () => {
      this.setUserKarmaMiles();
    });
  }

  setUserKarmaMiles() {
    this.karmaMile = _.get(this.user.info, 'stats.events.karmaMile')
      ? this.nFormatter(this.user.info.stats.events.karmaMile, 1)
      : undefined;
  }

  closeDrawer() {
    setTimeout(() => {
      this.tools.emit('close-main-drawer');
    });
  }

  navTo(tab, page) {
    this.closeDrawer();
    // this.checkAuthentication(page);
    this.selectedNav = tab;
    if (page !== 'jobs') {
      this.tools.navTo(page, tab, {}, true);
    } else {
      this.tools.openJobs(this.user.get('_id'), 'main-nav');
    }
  }

  openMailTo() {
    const userId = this.user.info._id;
    let s = `Contact Us Email from user: ${userId}`;
    window.open(`mailto:app@cdllife.com?subject=${s || ''}`, '_system');
  }

  openFaqs() {
    this.tools.openExternalUrl('https://app.cdllife.com/FAQ');
  }

  changeDevMode(e) {
    const res = String(prompt('Enter PR Number or url') || '').trim();

    if (!res) return;

    // number of PR
    if (res === String(parseInt(res))) {
      location.replace(`https://cdllife-mobile-app-pr-${res}.herokuapp.com`);
    } else if (/^http/.test(res)) {
      location.replace(res);
    } else {
      alert('Invalid PR Number or URL');
    }
  }

  checkAuthentication(key?) {
    if (this.user.userPermission(key)) {
      return true;
    } else {
      this.tools.loginBlock('Create an account to get started');
      return false;
    }
  }

  navToUsersProfile() {
    if (this.userNavBlocked) return;
    this.closeDrawer();
    setTimeout(() => {
      this.checkAuthentication('UserProfilePage') &&
        this.appCtrl.getActiveNav().push('UserProfilePage', {
          user: this.user,
          user_id: this.user.info._id,
        });
    }, 500);
  }

  openQrCodeModal() {
    const modal = this.modalCtrl.create('QRCodePage');
    modal.present();
  }

  openUserSettingsModal() {
    const modal = this.modalCtrl.create('UserSettingsPage');
    modal.present();
  }

  openReviewModal() {
    this.tools.emit('open-review-modal');
  }

  nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
      : '0';
  }
}



// WEBPACK FOOTER //
// ./src/components/drawer/drawer.ts